import _classCallCheck from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/**
 * Error that is thrown if a [[LinkTransport]] cancels a request.
 * @internal
 */
export var CancelError =
/*#__PURE__*/
function (_Error) {
  _inherits(CancelError, _Error);

  function CancelError(reason) {
    var _this;

    _classCallCheck(this, CancelError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CancelError).call(this, "User canceled request ".concat(reason ? '(' + reason + ')' : '')));
    _this.code = 'E_CANCEL';
    return _this;
  }

  return CancelError;
}(_wrapNativeSuper(Error));
/**
 * Error that is thrown if an identity request fails to verify.
 * @internal
 */

export var IdentityError =
/*#__PURE__*/
function (_Error2) {
  _inherits(IdentityError, _Error2);

  function IdentityError(reason) {
    var _this2;

    _classCallCheck(this, IdentityError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(IdentityError).call(this, "Unable to verify identity ".concat(reason ? '(' + reason + ')' : '')));
    _this2.code = 'E_IDENTITY';
    return _this2;
  }

  return IdentityError;
}(_wrapNativeSuper(Error));
/**
 * Error originating from a [[LinkSession]].
 * @internal
 */

export var SessionError =
/*#__PURE__*/
function (_Error3) {
  _inherits(SessionError, _Error3);

  function SessionError(reason, code) {
    var _this3;

    _classCallCheck(this, SessionError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(SessionError).call(this, reason));
    _this3.code = code;
    return _this3;
  }

  return SessionError;
}(_wrapNativeSuper(Error));